import styled, { css } from 'styled-components';

export const InfoPageOrderedList = styled.ol`
  list-style: none;
  counter-reset: item;
  font-size: 20px;

  @media (max-width: 440px) {
    font-size: 16px;
  }

  ${({ table }) =>
    table &&
    css`
      table,
      th,
      td {
        border: 1px solid rgba(134, 138, 159, 1);
        font-weight: 500;
        vertical-align: top;
        text-align: left;
      }

      th {
        padding: 10px 5px 10px 5px;
      }

      table {
        width: 100%;
        table-layout: fixed;
        word-break: normal;
        margin: 20px 0 20px 0;
      }
    `}
`;
